import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyARUdPrHOG3wVFi9KaWXPvu4DLmWK6uy9o",
    authDomain: "meet.revealiq.in",
    projectId: "revealiqmeet",
    storageBucket: "revealiqmeet.firebasestorage.app",
    messagingSenderId: "916076410520",
    appId: "1:916076410520:web:5c08f6ee5a0a2b066bc2ed",
    measurementId: "G-M594VNPYFL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db, analytics };
export default app;
